export { default } from "./Tab.mjs";
export { default as tabClasses } from "./tabClasses.mjs";
export * from "./tabClasses.mjs";